import { Pipe, PipeTransform } from '@angular/core';
import { SegmentoContrato } from '../../models/contrato/SegmentoContrato';

@Pipe({
  name: 'segmentoContrato',
})
export class SegmentoContratoPipe implements PipeTransform {
  transform(segmento: SegmentoContrato): string {
    return {
      [SegmentoContrato.Saude]: 'Saúde',
      [SegmentoContrato.Odontologico]: 'Odonto',
      [SegmentoContrato.Food]: 'Food',
    }[segmento];
  }
}
